import { Navbar, Nav, Container, Image } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import Logo from '../images/logoz1.png';
import defaultAvatar from '../images/Logo2.png';
import '../styles/Navbar.css';
import { useContext, React } from 'react';
import { AuthContext } from '../context/AuthContext';

const NavBar = () => {
  const navigate = useNavigate();
  const { currentUser, logout } = useContext(AuthContext);

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  const handleProfileClick = () => {
   return;
  };

  return (
    <Navbar className="bg-color my-nav fixed-top" variant="dark" expand="lg">
      <Container className="d-flex align-items-end justify-content-between">
        {/* Left: Logo */}
        <Navbar.Brand href="#" className="d-flex align-items-center">
          <img src={Logo} alt="Logo" className="Logo" />
        </Navbar.Brand>

      

        {/* Right: Hamburger Menu */}
        <Navbar.Toggle aria-controls="basic-navbar-nav" className="custom-navbar" />

        <Navbar.Collapse id="basic-navbar-nav">
          {/* Desktop Navigation Links */}
          <Nav className="my-nav-link mx-auto d-none d-lg-flex justify-content-center nav-gap me-nav" style={{ flex: 1, justifyContent: 'center' }}>
            <Link className="nav-link" to="/">Home</Link>
            <Link className="nav-link" to="/dashboard">Buy Data</Link>
            <Link className="nav-link" to="/dashboard">Airtime to Cash</Link>
            <Link className="nav-link" to="/dashboard">Pay Bills</Link>
          </Nav>

          {/* Right Side (Desktop Only) */}
          <Nav className="ms-auto d-none d-lg-flex my-gap">
            {currentUser ? (
              <>
                <Link className="nav-link nav-button" onClick={handleLogout} style={{ cursor: "pointer" }}>Logout</Link>
                <div className="profile-icon" onClick={handleProfileClick} style={{ cursor: 'pointer' }}>
                  <Image
                    src={currentUser.profileImage || defaultAvatar}
                    roundedCircle
                    width={24}
                    height={24}
                    alt="Profile Avatar"
                  />
                </div>
              </>
            ) : (
              <>
                <Link className="nav-link nav-button" to="/login">Login</Link>
                <Link className="nav-link nav-button" to="/register">Create Account</Link>
              </>
            )}
          </Nav>

          {/* Mobile Navigation (Inside Hamburger Menu) */}
          <Nav className="d-lg-none w-100">
            <Link className="nav-link" to="/">Home</Link>
            <Link className="nav-link" to="/dashboard">Buy Data</Link>
            <Link className="nav-link" to="/dashboard">Airtime to Cash</Link>
            <Link className="nav-link" to="/dashboard">Pay Bills</Link>
            {currentUser ? (
              <Link className="nav-link" onClick={handleLogout} style={{ cursor: "pointer" }}>Logout</Link>
            ) : (
              <>
                <Link className="nav-link nav-button" to="/login">Login</Link>
                <Link className="nav-link nav-button" to="/register">Create Account</Link>
              </>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavBar;
